import { supabase } from '@/integrations/supabase/client';
import type { PlatformReadPort } from '../core/platformReadTypes';

export type { PlatformReadPort } from '../core/platformReadTypes';

export const supabasePlatformReadPort: PlatformReadPort = {
  async getSettings() {
    const { data, error } = await supabase
      .from('platform_settings')
      .select('key, value');
    if (error) throw error;
    return data || [];
  },
};
